<template>
    <main>
        <FavoritePlayerSelection
            :selectedClubCode="clubCode"
            :filteredPlayerList="filteredPlayerList"
            :selectedPlayerIds="selectedPlayerIds"
            :isUpdating="isUpdating"
            :clubFavoritePlayerList="clubFavoritePlayerList"
            @go-to-club-selection="goToClubSelection"
            @update-favorite-players="updateFavoritePlayers"
            @fetch-favorite-players="fetchFavoritePlayers"
        />
    </main>
</template>

<script>
import FavoritePlayerSelection from './FavoritePlayerSelection.vue';
import { mixinJleague } from '../../mixin/utility'

export default {
    name: 'SelectFavoritePlayerForSignup',
    mixins: [mixinJleague],
    components: {
        FavoritePlayerSelection
    },
    props: {
        selectedClubCode: String,
        favoritePlayerList: Array,
        userinfo: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            clubCode: this.selectedClubCode,
            selectedPlayerIds: [null, null, null],
			clubFavoritePlayerList: [],
            isUpdating: false
        };
    },
    methods: {
        fetchFavoritePlayers() {
            if (this.userinfo && this.userinfo.favorite_player_list && this.userinfo.favorite_player_list.length > 0) {
                this.clubFavoritePlayerList = this.userinfo.favorite_player_list.find(club => club.club_cd === this.clubCode)?.player_list || [];
            }
        },
        goToClubSelection() {
			this.selectedClubCode = null;
			this.selectedPlayerIds = [null, null, null];
            this.$emit('change-view', 'SelectClub');
        },
        async updateFavoritePlayers(selectedPlayerIds, filteredPlayerList) {
            this.selectedPlayerIds = selectedPlayerIds;
            this.filteredPlayerList = filteredPlayerList;
            
            if (this.isUpdating) return;
            this.isUpdating = true;
			try {
				const selectedPlayers = this.selectedPlayerIds.filter(id => id !== null && id !== "null");
                const updatedFavoritePlayerList = this.filteredPlayerList
                    .filter(player => selectedPlayers.includes(player.player_id))
                    .sort((a, b) => selectedPlayers.indexOf(a.player_id) - selectedPlayers.indexOf(b.player_id));

                const clubIndex = this.favoritePlayerList.findIndex(club => club.club_cd === this.clubCode);
                let newFavoritePlayerList = [...this.favoritePlayerList];

                if (clubIndex !== -1) {
                    if (updatedFavoritePlayerList.length > 0) {
                        this.$set(newFavoritePlayerList, clubIndex, {
                            club_cd: this.clubCode,
                            player_list: updatedFavoritePlayerList
                        });
                    } else {
                        newFavoritePlayerList.splice(clubIndex, 1);
                    }
                } else if (updatedFavoritePlayerList.length > 0) {
                    newFavoritePlayerList.push({
                        club_cd: this.clubCode,
                        player_list: updatedFavoritePlayerList
                    });
                }

                this.favoritePlayerList.splice(0, this.favoritePlayerList.length, ...newFavoritePlayerList);
                this.userinfo.favorite_player_list = this.favoritePlayerList;
				this.goToClubSelection();
			} catch (error) {
				console.error('Error updating favorite players:', error);
                alert("お気に入り選手の登録に失敗しました。");
                this.goToClubSelection();
			} finally {
                this.isUpdating = false;
            }
		}
    }
};
</script>